export interface Category {
  slug: string;
  name: string;
  description: string;
  icon: string;
  count: number;
  imageSeq: string;
  imageQuery: string;
}

export const categories: Category[] = [
  {
    slug: 'story',
    name: '剧情向',
    description: '以深刻剧情和人物塑造为核心的galgame作品，注重情感表达与故事深度',
    icon: 'ri-book-open-line',
    count: 128,
    imageSeq: 'cat-story-01',
    imageQuery: 'Dreamy%20soft%20focus%20artistic%20composition%20with%20warm%20golden%20amber%20tones%2C%20floating%20book%20pages%20and%20ink%20particles%2C%20gentle%20cherry%20blossom%20petals%2C%20ethereal%20atmosphere%2C%20minimalist%20anime%20aesthetic%2C%20clean%20composition%2C%20warm%20cream%20background%20with%20subtle%20golden%20accents%2C%20editorial%20photography%20style%20with%20soft%20shadows',
  },
  {
    slug: 'romance',
    name: '恋爱养成',
    description: '专注于恋爱模拟与角色养成的galgame，体验甜蜜心动的恋爱故事',
    icon: 'ri-heart-line',
    count: 96,
    imageSeq: 'cat-romance-01',
    imageQuery: 'Soft%20romantic%20artistic%20composition%20with%20warm%20rose%20coral%20and%20pink%20tones%2C%20floating%20heart%20shaped%20particles%2C%20gentle%20bokeh%20effects%2C%20dreamy%20spring%20atmosphere%2C%20minimalist%20anime%20aesthetic%2C%20clean%20composition%2C%20warm%20cream%20background%2C%20editorial%20photography%20style%20with%20soft%20lighting',
  },
  {
    slug: 'mystery',
    name: '悬疑推理',
    description: '扣人心弦的悬疑推理系galgame，在层层谜团中寻找真相',
    icon: 'ri-search-eye-line',
    count: 64,
    imageSeq: 'cat-mystery-01',
    imageQuery: 'Moody%20artistic%20composition%20with%20warm%20amber%20and%20deep%20brown%20tones%2C%20mysterious%20floating%20key%20and%20lock%20silhouettes%2C%20subtle%20fog%20effect%2C%20film%20noir%20inspired%20atmosphere%2C%20minimalist%20anime%20aesthetic%2C%20clean%20composition%2C%20warm%20cream%20background%2C%20editorial%20photography%20style',
  },
  {
    slug: 'scifi',
    name: '科幻冒险',
    description: '未来科技与冒险探索主题的galgame，展开宏大的科幻世界',
    icon: 'ri-rocket-line',
    count: 52,
    imageSeq: 'cat-scifi-01',
    imageQuery: 'Futuristic%20artistic%20composition%20with%20warm%20amber%20and%20copper%20tones%2C%20floating%20geometric%20shapes%20and%20star%20particles%2C%20subtle%20digital%20grid%20patterns%2C%20cosmic%20atmosphere%2C%20minimalist%20anime%20aesthetic%2C%20clean%20composition%2C%20warm%20cream%20background%2C%20editorial%20photography%20style',
  },
  {
    slug: 'fantasy',
    name: '奇幻世界',
    description: '魔法与异世界冒险主题的galgame，沉浸于瑰丽的奇幻旅程',
    icon: 'ri-magic-line',
    count: 73,
    imageSeq: 'cat-fantasy-01',
    imageQuery: 'Enchanting%20artistic%20composition%20with%20warm%20golden%20and%20emerald%20tones%2C%20floating%20magical%20sparkles%20and%20crystal%20shapes%2C%20soft%20glow%20effects%2C%20fairy%20tale%20atmosphere%2C%20minimalist%20anime%20aesthetic%2C%20clean%20composition%2C%20warm%20cream%20background%2C%20editorial%20photography%20style',
  },
  {
    slug: 'horror',
    name: '恐怖惊悚',
    description: '紧张刺激的恐怖惊悚系galgame，在恐惧中体验极限情感',
    icon: 'ri-ghost-line',
    count: 38,
    imageSeq: 'cat-horror-01',
    imageQuery: 'Atmospheric%20artistic%20composition%20with%20deep%20crimson%20and%20dark%20amber%20tones%2C%20floating%20shadow%20silhouettes%2C%20subtle%20fog%20and%20mist%20effects%2C%20gothic%20atmosphere%2C%20minimalist%20anime%20aesthetic%2C%20clean%20composition%2C%20warm%20cream%20background%2C%20editorial%20photography%20style',
  },
];